/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! GhostStat Funnels — builder.
 *
 *  The backend has always been able to create funnels: POST /plugin/funnels/save takes
 *  { id?, name, conv_window_days, enforce_order, steps:[{ordinal,kind,match_op,match_value,label,branch_group}] }
 *  and FunnelLogic::saveFunnel() writes funnels + funnel_steps. There was simply no way to call it
 *  from the UI — so "why can't I add my own funnels?" had no answer beyond "nobody built the form".
 *
 *  /suggest returns the site's real top pages and event names, so the step picker offers things
 *  that actually exist rather than a blank box to guess into.
 */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  try { (window.GS_BUILD = window.GS_BUILD || {})["funnels-builder"] = "1"; } catch (e) {}

  var root, MODEL = null, SUGGEST = { pages: [], events: [] }, onSaved = null;

  function q(k) { return root ? root.querySelector('[data-fb="' + k + '"]') : null; }
  function qa(s) { return root ? Array.prototype.slice.call(root.querySelectorAll(s)) : []; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function api(p, o) { return GS.api(p + (p.indexOf("?") < 0 ? "?" : "&") + "site=" + encodeURIComponent(GS.site), o); }

  /* Only what FunnelLogic::saveFunnel actually accepts. Offering "regex" or "ends with" here would
     be a lie: the backend clamps match_op to is|contains|starts and silently rewrites anything
     else to "is", so the funnel would quietly measure something other than what the form said. */
  var KINDS = [
    { k: "page",    label: TR('funnel.g.page'),    hint: "A pageview whose path matches." },
    { k: "event",   label: TR('funnel.g.event'),   hint: "A custom event by name — whatever gs.track() sends." },
    { k: "utm",     label: TR('funnel.g.utm_source'), hint: TR('funnel.f3.the_campaign_source_that_brought_t') },
    { k: "device",  label: TR('funnel.g.device'),  hint: "desktop, mobile, tablet or tv." },
    { k: "browser", label: TR('funnel.g.browser'), hint: "Chrome, Safari, Firefox…" },
    { k: "country", label: TR('funnel.g.country'), hint: "A two-letter country code, e.g. US." }
  ];
  var OPS = [
    { k: "is",       label: "is exactly" },
    { k: "contains", label: "contains" },
    { k: "starts",   label: "starts with" }
  ];

  function blank() { return { id: 0, name: "", conv_window_days: 7, enforce_order: 1, steps: [
    { kind: "page", match_op: "is", match_value: "/", label: "" },
    { kind: "page", match_op: "is", match_value: "", label: "" }
  ] }; }

  function stepRow(s, i, n) {
    var kind = KINDS.filter(function (x) { return x.k === s.kind; })[0] || KINDS[0];
    var list = s.kind === "event" ? SUGGEST.events : (s.kind === "page" ? SUGGEST.pages : []);
    return '<div class="fb-step" data-i="' + i + '">' +
      '<div class="fb-ord">' + (i + 1) + "</div>" +
      '<div class="fb-fields">' +
        '<select class="fb-in fb-kind" title="' + esc(kind.hint) + '">' + KINDS.map(function (k) {
          return '<option value="' + k.k + '"' + (k.k === s.kind ? " selected" : "") + ' title="' + esc(k.hint) + '">' + k.label + "</option>";
        }).join("") + "</select>" +
        '<select class="fb-in fb-op">' + OPS.map(function (o) {
          return '<option value="' + o.k + '"' + (o.k === s.match_op ? " selected" : "") + ">" + o.label + "</option>";
        }).join("") + "</select>" +
        '<span class="fb-val-wrap">' +
          '<input class="fb-in fb-val" list="fb-sug-' + i + '" value="' + esc(s.match_value) + '" placeholder="' +
            (s.kind === "page" ? "/pricing" : s.kind === "event" ? "signup" : "value") + '">' +
          '<datalist id="fb-sug-' + i + '">' + list.map(function (x) {
            return '<option value="' + esc(x.v) + '">' + esc(x.n ? x.v + "  (" + x.n + ")" : x.v) + "</option>"; }).join("") + "</datalist>" +
        "</span>" +
        '<input class="fb-in fb-label" value="' + esc(s.label || "") + '" placeholder="'+TT('fn.at.label_optional')+'" ' +
          'title="'+TT('fn.tip.stepname')+'">' +
      "</div>" +
      '<div class="fb-acts">' +
        '<button type="button" class="fb-mini fb-up" ' + (i === 0 ? "disabled" : "") + ' title="'+TT('fn.tip.moveup')+'">&#9650;</button>' +
        '<button type="button" class="fb-mini fb-dn" ' + (i === n - 1 ? "disabled" : "") + ' title="'+TT('fn.tip.movedown')+'">&#9660;</button>' +
        '<button type="button" class="fb-mini fb-rm" ' + (n <= 2 ? "disabled" : "") +
          ' title="' + (n <= 2 ? "A funnel needs at least two steps" : TT('fn.m.remove_this_step')) + '">&times;</button>' +
      "</div></div>";
  }

  function draw() {
    if (!root || !MODEL) return;
    q("name").value = MODEL.name || "";
    q("win").value = MODEL.conv_window_days || 7;
    q("order").checked = !!MODEL.enforce_order;
    q("steps").innerHTML = MODEL.steps.map(function (s, i) { return stepRow(s, i, MODEL.steps.length); }).join("");
    q("title").textContent = MODEL.id ? "Edit funnel" : TR('funnel.g.new_funnel');
    q("del").hidden = !MODEL.id;
    wire();
  }

  function read() {
    MODEL.name = q("name").value.trim();
    MODEL.conv_window_days = Math.max(1, Math.min(90, parseInt(q("win").value, 10) || 7));
    MODEL.enforce_order = q("order").checked ? 1 : 0;
    qa(".fb-step").forEach(function (el) {
      var i = +el.getAttribute("data-i"), s = MODEL.steps[i]; if (!s) return;
      s.kind = el.querySelector(".fb-kind").value;
      s.match_op = el.querySelector(".fb-op").value;
      s.match_value = el.querySelector(".fb-val").value.trim();
      s.label = el.querySelector(".fb-label").value.trim();
    });
  }

  function wire() {
    qa(".fb-kind").forEach(function (el) { el.addEventListener("change", function () { read(); draw(); }); });
    qa(".fb-up").forEach(function (b) { b.addEventListener("click", function () {
      read(); var i = +b.closest(".fb-step").getAttribute("data-i");
      if (i > 0) { var t = MODEL.steps[i - 1]; MODEL.steps[i - 1] = MODEL.steps[i]; MODEL.steps[i] = t; draw(); } }); });
    qa(".fb-dn").forEach(function (b) { b.addEventListener("click", function () {
      read(); var i = +b.closest(".fb-step").getAttribute("data-i");
      if (i < MODEL.steps.length - 1) { var t = MODEL.steps[i + 1]; MODEL.steps[i + 1] = MODEL.steps[i]; MODEL.steps[i] = t; draw(); } }); });
    qa(".fb-rm").forEach(function (b) { b.addEventListener("click", function () {
      read(); var i = +b.closest(".fb-step").getAttribute("data-i");
      if (MODEL.steps.length > 2) { MODEL.steps.splice(i, 1); draw(); } }); });
  }

  function validate() {
    read();
    if (!MODEL.name) return "Give the funnel a name.";
    if (MODEL.steps.length < 2) return "A funnel needs at least two steps.";
    for (var i = 0; i < MODEL.steps.length; i++)
      if (!MODEL.steps[i].match_value) return "Step " + (i + 1) + " has no value to match on.";
    return null;
  }

  function save() {
    var err = validate();
    if (err) { q("err").textContent = err; q("err").hidden = false; return; }
    q("err").hidden = true;
    var b = q("save"); b.disabled = true; b.textContent = TT('fn.a.saving_u2026');
    MODEL.steps.forEach(function (s, i) { s.ordinal = i; s.branch_group = s.branch_group || ""; });
    api("/plugin/funnels/save", { method: "POST", body: JSON.stringify(MODEL) }).then(function (r) {
      b.disabled = false; b.textContent = TT('fn.a.save_funnel');
      if (!r || !r.ok) { q("err").textContent = (r && r.error) ? ("Could not save: " + r.error) : TR('funnel.g.could_not_save'); q("err").hidden = false; return; }
      close();
      if (onSaved) onSaved(r.data && r.data.id ? r.data.id : (r.id || MODEL.id));
    }).catch(function () { b.disabled = false; b.textContent = TT('fn.a.save_funnel');
      q("err").textContent = TT('fn.a.could_not_save'); q("err").hidden = false; });
  }

  function del() {
    if (!MODEL.id) return;
    if (!confirm('Delete "' + (MODEL.name || "this funnel") + '"? The report goes with it; the underlying pageviews and events are untouched.')) return;
    api("/plugin/funnels/delete", { method: "POST", body: JSON.stringify({ id: MODEL.id }) }).then(function () {
      close(); if (onSaved) onSaved(0);
    });
  }

  function open(model, cb) {
    MODEL = model || blank(); onSaved = cb || null;
    root = document.querySelector('[data-fb="modal"]'); if (!root) return;
    root.hidden = false;
    api("/plugin/funnels/suggest").then(function (r) {
      var d = (r && r.data) || {};
      SUGGEST = { pages: d.pages || [], events: d.events || [] };
      draw();
    }).catch(draw);
    draw();
  }
  function close() { if (root) root.hidden = true; }

  /* Public: the page opens the builder for a new funnel or an existing one. */
  window.GSFunnelBuilder = {
    create: function (cb) { open(blank(), cb); },
    edit: function (funnel, cb) {
      var m = {
        id: funnel.id, name: funnel.name || "",
        conv_window_days: funnel.conv_window_days || 7,
        enforce_order: funnel.enforce_order == null ? 1 : (funnel.enforce_order ? 1 : 0),
        steps: (funnel.steps || []).map(function (s) {
          return { kind: s.kind || "page", match_op: s.match_op || "is",
                   match_value: s.match_value || "", label: s.label || "", branch_group: s.branch_group || "" };
        })
      };
      if (m.steps.length < 2) m.steps = blank().steps;
      open(m, cb);
    },
    close: close
  };

  document.addEventListener("click", function (e) {
    var m = document.querySelector('[data-fb="modal"]');
    if (!m || m.hidden) return;
    if (e.target === m) close();                         // click the backdrop
    if (e.target.closest('[data-fb="close"]')) close();
    if (e.target.closest('[data-fb="save"]')) save();
    if (e.target.closest('[data-fb="del"]')) del();
    if (e.target.closest('[data-fb="add"]')) {
      read(); MODEL.steps.push({ kind: "page", match_op: "is", match_value: "", label: "" }); draw();
    }
  });
  document.addEventListener("keydown", function (e) {
    var m = document.querySelector('[data-fb="modal"]');
    if (m && !m.hidden && e.key === TR('funnel.g.escape')) close();
  });
})();
